import {ajax} from '../modules/ajax';
/*
*
*
* */

class AllAjax {
	constructor(wrapper) {
        this._createElements(wrapper);
        this._addEvents();
    }

    _createElements(wrapper){
        this.wrapper = wrapper;
        this.param = JSON.parse(wrapper.getAttribute('data-param'));
        this.btn = this.wrapper.nextElementSibling.querySelector('[data-allAjax-btn="'+ this.param.name  +'"]');
        this.modules = APP.modules.run(this.wrapper, 'data-allAjax-modules');
        this.isSending = false;
    }

    _addEvents(){
        var self = this;

        this.btn.onclick = function(e){
            self._getContent.call(self, e)
        }
    }

    _getContent(e){
        e.preventDefault();
        var self = this;

        if(this.isSending) return;
        this.isSending = true;

        ajax({
            url:this.btn.href,
            callback: function(msg){
                self._addContent.call(self, msg);
            }
        });
    }

    _addContent(msg){
        APP.modules.destroy(this.modules);
        this.wrapper.innerHTML = msg;
        this.modules = APP.modules.run(this.wrapper, 'data-allAjax-modules');
        this.btn.onclick = null;
        this.btn.style.display = 'none';
    }

    del(){
        APP.modules.destroy(this.modules);
        this.btn.onclick = null;
        for(var key in this){
            delete this[key];
        }
    }
};

export {AllAjax};



